import { Link, useMatches } from "react-router-dom";
import styles from "./breadcrumb.module.css";

function Breadcrumb() {
  const matches = useMatches();

  const crumbs = matches
    .filter(match => match.handle?.crumb)
    .map(match => ({
      label:
        typeof match.handle.crumb === "function"
          ? match.handle.crumb(match.data)
          : match.handle.crumb,
      path: match.pathname,
    }));

  return (
    <nav className={styles.breadcrumb}>
      {crumbs.map((crumb, index) => (
        <span key={index}>
          <Link to={crumb.path}>{crumb.label}</Link>
          {index < crumbs.length - 1 && " / "}
        </span>
      ))}
    </nav>
  );
}

export default Breadcrumb;
